import { useQuery } from 'react-query';
import { axios } from 'lib/axios';

export const getJobAdVersions = ({ jobAdId, page, limit }) => {
  return axios.get(`/api/job_ads/${jobAdId}/versions`, {
    params: { offset: page * limit, limit },
  });
};

export const useJobAdVersions = (jobAdId, { page, limit = 10, queryOptions }) => {
  const { data, ...rest } = useQuery(
    ['job-ad-versions', jobAdId, page, limit],
    () => getJobAdVersions({ jobAdId, page, limit }),
    {
      ...queryOptions,
      select: ({ data }) => ({
        versions: data.rows,
        total: data.count,
      }),
    }
  );

  return { data: data || { versions: [], total: 0 }, ...rest };
};
